import { useEffect, useState } from 'react';

import { META_COLLECT_API } from '../../../../api';
import { DontExistsItem } from '../../../../components/DontExistsItem';
import { DontExistsItemFlex } from '../../../../components/DontExistsItem/styles';
import { LoadingData } from '../../../../components/LoadingData';
import { useSigninContext } from '../../../../context/AuthProviderPages/Signin';
import { usePageContext } from '../../../../context/usePage';
import { Paginator } from '../components/paginator';
import { ContentWrapper } from './components/content-wrapper';
import { Table } from './components/table';

export type PQFLAnswerItem = {
  id: number;
  valor: string;
  status: string;
  observacao: string;
  grau1_pergunta: string;
  grau2_pergunta: string;
  texto_pergunta: string;
  observacao_pergunta: string | null;
  tipo_pergunta: number;
  obrigatorio_pergunta: string;
  ordem_pergunta: number;
  data_criacao: string;
  data_atualizacao: string;
};

export type PQFLAnswer = {
  id: number;
  status: string;
  data_criacao: string;
  data_atualizacao: string;
  questionario: {
    id: number;
    descricao: string;
  };
  itens: PQFLAnswerItem[];
};

export type PQFLVisitRow = {
  id: number;
  status: string;
  descricao: string | null;
  data_inicio: string;
  data_final: string | null;
  recomendacao_tecnica: string | null;
  propriedade: {
    id: number;
    ativo: string;
    cnpj_cpf_cei: string;
    nome_propriedade: string;
    nome_produtor: string;
    nome_municipio: string;
    id_sigla_uf: string;
    logradouro: string;
    numero: string;
    data_atualizacao: string;
    matricula: string;
  };
  unidade: {
    id: number;
    nome: string;
  };
  funcionario: {
    id: number;
    nome: string;
  };
  respostas: PQFLAnswer[];
};

export const PQFLVisitsPage = () => {
  const { setSelectedPage } = usePageContext();
  const { path } = useSigninContext();

  const [loading, setLoading] = useState<boolean>(false);
  const [rows, setRows] = useState<PQFLVisitRow[]>([]);
  const [selectedRow, setSelectedRow] = useState<PQFLVisitRow | null>(null);
  const [hasMore, setHasMore] = useState<boolean>(false);
  const [count, setCount] = useState<number>(0);
  const [limit, setLimit] = useState<number>(15);
  const [page, setPage] = useState<number>(1);

  const fetchVisits = async () => {
    try {
      const { data: response } = await META_COLLECT_API.get(
        `/pqfl/visits?limit=${limit}&page=${page}`,
        {
          headers: { path },
        },
      );
      setHasMore(response.hasMore);
      setCount(response.count);
      setRows(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setSelectedPage({ option: 'pqfl_visitas' });
  }, []);

  useEffect(() => {
    setLoading(true);
    fetchVisits().finally(() => setLoading(false));
  }, [limit, page]);

  if (loading) {
    return (
      <ContentWrapper
        loading={loading}
        row={selectedRow}
        openModal={!!selectedRow}
        handleCloseModal={() => setSelectedRow(null)}
      >
        <LoadingData title="Carregando..." />
      </ContentWrapper>
    );
  }

  return (
    <ContentWrapper
      loading={loading}
      row={selectedRow}
      openModal={!!selectedRow}
      handleCloseModal={() => setSelectedRow(null)}
    >
      {rows.length ? (
        <>
          <Table rows={rows} setSelectedRow={setSelectedRow} />
          <Paginator
            size={rows.length}
            limit={limit}
            setLimit={setLimit}
            page={page}
            setPage={setPage}
            hasMore={hasMore}
            count={count}
          />
        </>
      ) : (
        <DontExistsItemFlex>
          <DontExistsItem title="Nenhuma pergunta encontrada" />
        </DontExistsItemFlex>
      )}
    </ContentWrapper>
  );
};
